import React from 'react';
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaGlobe } from 'react-icons/fa';

const GroupsSection = () => {
  const groups = [
    {
      name: 'R D S College of Pharmacy',
      short: 'Pharmacy College',
      description: 'Approved by PCI New Delhi, Affiliated to AKTU Lucknow And UPBTE. Offering B.Pharm and  D.Pharm programs.',
      logo: '/logo.png',
      color: 'from-blue-600 to-blue-400',
      bgColor: 'bg-blue-50',
      link: 'https://rdspharmacy.com', 
    },
    {
      name: 'R D S Nursing and Paramedical College',
      short: 'Nursing & Paramedical',
      description: 'Recognized by Indian Nursing Council. Courses in Bsc Nursing, GNM. afflited to ABVMU, & UP State Medical Facility .',
      logo: 'logo1.png',
      color: 'from-orange-600 to-orange-400',
      bgColor: 'bg-orange-50',
      link: 'https://paramedical.rdsgroupofcolleges.com', 
    },
    {
      name: 'R.D.S. Mahavidyalaya',
      short: 'Degree College',
      description: 'Affiliated to VBS Purvanchal University, Jaunpur. Offers programs. BBA, BCA, MSC ,BSC, BA, MA, DELED.',
      logo: 'logo2.png',
      color: 'from-blue-600 to-blue-400',
      bgColor: 'bg-blue-50',
      link: 'https://mahavidyalaya.rdsgroupofcolleges.com', 
    },
    {
      name: 'Sharda Private ITI',
      short: 'Industrial Training Institute',
      description: 'NCVT Affiliated. Trades: Electrician, Fitter, ',
      logo: 'logo3.png',
      color: 'from-orange-600 to-orange-400',
      bgColor: 'bg-orange-50',
      link: 'https://iti.rdsgroupofcolleges.com', 
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 to-orange-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">Our Groups</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-orange-500 mx-auto"></div>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Excellence in education across multiple disciplines
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {groups.map((group, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden"
            >
              <div className={`h-2 bg-gradient-to-r ${group.color}`}></div>
              
              <div className="p-6">
                <div className={`w-20 h-20 ${group.bgColor} rounded-2xl flex items-center justify-center mb-4 p-3 mx-auto transform group-hover:scale-110 transition-transform duration-300`}>
                  <img
                    src={group.logo}
                    alt={group.name}
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://via.placeholder.com/80?text=Logo';
                    }}
                  />
                </div>
                
                <h3 className="text-xl font-bold text-gray-800 mb-1 text-center">{group.name}</h3>
                <p className="text-sm text-orange-600 font-medium mb-3 text-center">{group.short}</p>
                <p className="text-gray-600 text-sm mb-4 text-center">{group.description}</p>
                
                <a
                  href={group.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-full text-blue-600 hover:text-orange-600 font-medium text-sm transition-colors"
                >
                  Learn More
                  <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden mb-20">
          <div className="grid md:grid-cols-2">
            <div className="bg-gradient-to-br from-blue-600 to-orange-500 p-8 flex flex-col items-center justify-center text-white">
              <img
                src="/rds logo.png"
                alt="RDS Group of Colleges"
                className="w-28 h-28 object-contain mb-3 bg-white bg-opacity-20 p-2 rounded-2xl"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/120?text=Logo';
                }}
              />
              <h3 className="text-2xl font-bold text-center mb-1">RDS Group of Colleges</h3>
              
              {/* Courses added here - below the text */}
              <div className="mt-4 pt-3 border-t border-white/30 w-full text-center">
                <p className="text-white text-xs font-medium">📚 Courses Offered:</p>
                <p className="text-white text-xs mt-1 leading-relaxed">
                  Pharmacy: B.Pharm, D.Pharm | Nursing: B.Sc Nursing, GNM | Degree:BBA, BCA, MSC BSC, BA, MA, DELED | ITI: Electrician, Fitter
                </p>
              </div>
            </div>
            <div className="p-10">
              <h4 className="text-2xl font-bold text-blue-900 mb-6">Contact Information</h4>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <FaMapMarkerAlt className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0" />
                  <p className="text-gray-700">Village - Kushnow, Post - Bhaupur, District - Jaunpur, Pin - 222136 (Uttar Pradesh)</p>
                </div>
                <div className="flex items-center space-x-3">
                  <FaEnvelope className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <a href="mailto:rdspharmacycollege@gmail.com" className="text-gray-700 hover:text-orange-600 transition-colors">rdspharmacycollege@gmail.com</a>
                </div>
                <div className="flex items-center space-x-3">
                  <FaPhone className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <p className="text-gray-700">+91 9628362187, +91 7275370808 , +91 7607094014</p>
                </div>
                <div className="flex items-center space-x-3">
                  <FaGlobe className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <a href="https://pharmacy.rdsgroupofcolleges.com" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-orange-600 transition-colors">
                    pharmacy.rdsgroupofcolleges.com , rdscollege0342@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="mt-8 pt-6 border-t border-gray-200">
                <p className="text-gray-600 italic">
                  "Committed to excellence in pharmaceutical education and research."
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="relative rounded-3xl overflow-hidden">
          <div className="absolute inset-0 bg-blue-900 opacity-5" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, gray 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
          
          <div className="relative bg-white bg-opacity-90 backdrop-blur-sm p-10 md:p-14 text-center">
            <p className="text-xl text-gray-800 italic mb-6 leading-relaxed">
              "Like our former president Dr. A.P.J. Abdul Kalam, it is our wishful thinking to visualize 100% literacy in the nation by 2020 by fulfilling our sacred duty of providing a platform which is very essential and aims at multi-dimensional objectives to take youngsters to glorious heights in different fields and transforming them into tomorrow's entrepreneurs who will be proficient in their respective fields."
            </p>
            <p className="text-lg text-gray-700 font-medium">
              At Innovative, we have the zeal to groom leaders who are not only thorough professionals but also good human beings with good values & excellent interpersonal skills. We aim to be a world class center for professional learning driven by professionalism, dynamism, innovation and a good value system.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GroupsSection;